import { render, staticRenderFns } from "./categorySelector.vue?vue&type=template&id=9aa444a6&scoped=true&"
import script from "./categorySelector.vue?vue&type=script&lang=js&"
export * from "./categorySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa444a6",
  null
  
)

export default component.exports